(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("oidc-client"));
	else if(typeof define === 'function' && define.amd)
		define([, "oidc-client"], factory);
	else if(typeof exports === 'object')
		exports["vue-oidc-client"] = factory(require("vue"), require("oidc-client"));
	else
		root["vue-oidc-client"] = factory(root["Vue"], root["oidc-client"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_c097__) {
return 